// ABOUTME: Pill toggle of the preview and result steps that picks which rows the table lists (Changes, Skipped, …).
// ABOUTME: Selected: the light primary tint of the design system's selected tabs; otherwise the neutral chip grey.

import { Box } from '@ds/coolshop';

/** The design system's selected-tab background. */
const SELECTED_BACKGROUND = '#E7E9F5';

type FilterChipProps = {
    label: string;
    selected: boolean;
    onClick: () => void;
    'data-testid'?: string;
};

export function FilterChip({ label, selected, onClick, 'data-testid': testId }: FilterChipProps) {
    return (
        <Box
            component="button"
            aria-pressed={selected}
            onClick={onClick}
            data-testid={testId}
            border={0}
            borderRadius={50}
            px={1.25}
            py={0.25}
            minHeight={24}
            cursor="pointer"
            typography="caption"
            fontFamily="inherit"
            bgcolor={selected ? SELECTED_BACKGROUND : 'action.selected'}
            color={selected ? 'primary.main' : 'text.primary'}
        >
            {label}
        </Box>
    );
}
